import * as util from "./util"
import * as utillogin from "./utillogin"
import Toastify from "toastify-js"
import "toastify-js/src/toastify.css"

/* To locally debug this script via Webflow the best option I've found is to
add two scripts in Webflow:
<script src="http://localhost:3000/????.bundle.js"></script>
<script src="angry-boyd-1669aa.netlify.app/????.bundle.js" crossorigin="anonymous"></script>
The below check ensures that if localhost loads successfully the second
(production) script won't run.
Initially I tried to add the script dynamically in Webflow but that didn't
work - I needed it to run immediately but it wouldn't. */
if (typeof SharesyWebflow === "undefined") {
  var welcomeMessage
  var welcomeMessagePart1

  util.initSentry()

  window.amplitudeOnLoad = function (instance) {
    if (window.location.pathname === "/host-confirm") {
      util.amplitudeInit(instance, "Host Confirm Page Viewed")
    } else if (window.location.pathname === "/dashboard-host-confirm") {
      util.amplitudeInit(instance, "Dashboard Host Confirm Page Viewed")
    } else if (window.location.pathname === "/host-cancel") {
      util.amplitudeInit(instance, "Host Cancel Page Viewed")
    } else if (window.location.pathname === "/dashboard-host-cancel") {
      util.amplitudeInit(instance, "Dashboard Host Cancel Page Viewed")
    } else if (window.location.pathname === "/host-onsite-contact") {
      util.amplitudeInit(instance, "Host Onsite Contact Page Viewed")
    } else if (window.location.pathname === "/dashboard-onsite-contact") {
      util.amplitudeInit(instance, "Dashboard Onsite Contact Page Viewed")
    }
  }

  // Wrap everything with Revealing Module Pattern
  window.SharesyWebflow = (function () {
    var searchParams = util.getSearchParams()

    function logAmplitudeEvent(eventName, eventProps) {
      let eventProperties = {}
      if (eventProps) {
        eventProperties = eventProps
      }
      try {
        eventProperties["id"] = searchParams.get("id")
      } catch (err) {}
      util.logAmplitudeEvent(eventName, eventProperties)
    }

    async function initClerk() {
      if (await isDashboardPage()) {
        // Redirect if not already logged in
        await utillogin.getClerkToken()
        utillogin.displayAdminNavItems()
      }
    }

    async function isDashboardPage() {
      if (
        window.location.pathname == "/dashboard-onsite-contact" ||
        window.location.pathname == "/dashboard-host-confirm" ||
        window.location.pathname == "/dashboard-host-cancel"
      ) {
        return true
      }
      return false
    }

    async function hostConfirmInit() {
      try {
        let id = searchParams.get("id")
        if (id) {
          try {
            const confirmData = await util.api
              .get("host-confirm?id=" + id, { retry: { limit: 4 } })
              .json()

            if (confirmData.error) {
              document.getElementById("error-message").innerHTML = ""
              document.getElementById("error-message").innerText =
                confirmData.error
              document.getElementById("error-section").style.display = "flex"
              document.getElementById("host-confirmed").style.display = "none"
              logAmplitudeEvent("Host Confirm Error Shown")
            } else if (confirmData.rescheduled) {
              document.getElementById("error-heading").innerText =
                "This booking has been rescheduled"
              let errorMessageElement = document.getElementById("error-message")
              errorMessageElement.innerHTML = ""
              let errorText =
                "It has been rescheduled to " +
                confirmData.event_date_times_string +
                ". If you can host it please "
              errorMessageElement.appendChild(
                document.createTextNode(errorText)
              )
              let confirmLink = document.createElement("a")
              confirmLink.className = "link-red"
              confirmLink.href =
                "https://www.sharesy.com/host-confirm?id=" +
                encodeURIComponent(confirmData.reschedule_id)
              confirmLink.textContent = "click to confirm"
              errorMessageElement.appendChild(confirmLink)
              errorMessageElement.appendChild(document.createTextNode("."))

              document.getElementById("error-section").style.display = "flex"
              document.getElementById("host-confirmed").style.display = "none"
              logAmplitudeEvent("Host Confirm Reschedule Message Shown")
            } else if (
              confirmData.first_name &&
              confirmData.space_or_venue_name &&
              confirmData.casual_event_date_string
            ) {
              if (confirmData.fast_confirm) {
                document.getElementById("success-message-text").innerText =
                  "Thanks for confirming within one day! Confirming quickly boosts your ranking on sharesy.com."
              }
              welcomeMessagePart1 =
                "Hi " +
                confirmData.first_name +
                ",\n\n" +
                "We're looking forward to welcoming you to " +
                confirmData.space_or_venue_name
              if (confirmData.multiple_appointment_purchase) {
                welcomeMessagePart1 += ".\n\n"
              } else {
                welcomeMessagePart1 +=
                  " on " + confirmData.casual_event_date_string + ".\n\n"
              }
              if (confirmData.default_welcome_message) {
                welcomeMessage =
                  welcomeMessagePart1 + confirmData.default_welcome_message
              } else {
                welcomeMessage =
                  welcomeMessagePart1 +
                  "Please let us know if you have any questions about your hire."
              }
              document.getElementById("message-text").value = welcomeMessage

              if (confirmData.welcome_message) {
                document.getElementById("success-message").classList.add("hide")
                document
                  .getElementById("warning-message")
                  .classList.remove("hide")
              }

              if (confirmData.booker_requests || confirmData.other_responses) {
                let bookerRequests = document.getElementById("booker-requests")
                let requests = []
                if (confirmData.booker_requests) {
                  requests = requests.concat(confirmData.booker_requests)
                }
                if (confirmData.other_responses) {
                  requests = requests.concat(confirmData.other_responses)
                }
                requests.forEach((element) => {
                  let requestContainer = document.createElement("div")
                  let requestName = document.createElement("div")
                  requestName.classList.add("text-light")
                  requestName.innerText = element.name
                  let requestValue = document.createElement("div")
                  requestValue.innerText = element.value
                  requestContainer.appendChild(requestName)
                  requestContainer.appendChild(requestValue)
                  bookerRequests.appendChild(requestContainer)
                })
                bookerRequests.classList.remove("hide")
                document
                  .getElementById("booker-requests-title")
                  .classList.remove("hide")
              }
              logAmplitudeEvent("Host Confirmed")

              document
                .getElementById("message-button")
                .addEventListener("click", async function (e) {
                  let confirmForm = document.getElementById("confirm-form")
                  if (confirmForm.checkValidity()) {
                    e.preventDefault()
                    let button = document.getElementById("message-button")
                    let buttonText = button.value
                    window.requestAnimationFrame(() => {
                      button.value = "Please wait..."
                      button.disabled = true
                    })
                    try {
                      const sendWelcomeData = await util.api
                        .post("send-host-welcome", {
                          json: {
                            id: id,
                            welcome_message:
                              document.getElementById("message-text").value,
                          },
                          retry: { limit: 0 },
                        })
                        .json()
                      if (sendWelcomeData.sent) {
                        document
                          .getElementById("warning-message")
                          .classList.add("hide")
                        Toastify({
                          text: "Your welcome message has been sent.",
                          duration: 4000,
                          close: true,
                          gravity: "top",
                          position: "center",
                          stopOnFocus: true,
                          style: {
                            background: "#1aa979",
                          },
                        }).showToast()

                        document
                          .getElementById("send-welcome-message-section")
                          .classList.add("hide")
                        document
                          .getElementById("change-welcome-message-section")
                          .classList.remove("hide")
                        if (
                          document.getElementById("message-text").value !=
                          welcomeMessage
                        ) {
                          document.getElementById(
                            "change-welcome-message-question"
                          ).innerText =
                            "It looks like you changed the welcome message - would you like to save a different message for next time?"
                        }
                        logAmplitudeEvent("Host Welcome Message Sent")
                      } else {
                        console.error("invalid data")
                        document.getElementById("error-message").innerHTML =
                          'An error occurred while sending your message. Please try again later or contact us: <a href="mailto:venuesupport@sharesy.com" class="link-red">venuesupport@sharesy.com</a>.'
                        document.getElementById("error-section").style.display =
                          "flex"
                        button.disabled = false
                        button.value = buttonText
                        logAmplitudeEvent("Error Sending Host Welcome")
                      }
                    } catch (err) {
                      document.getElementById("error-message").innerHTML =
                        'An error occurred while sending your message. Please try again later or contact us: <a href="mailto:venuesupport@sharesy.com" class="link-red">venuesupport@sharesy.com</a>.'
                      document.getElementById("error-section").style.display =
                        "flex"
                      button.disabled = false
                      button.value = buttonText
                      logAmplitudeEvent("Error Sending Host Welcome", {
                        error: err.toString(),
                      })
                    }
                  } else {
                    confirmForm.reportValidity()
                    logAmplitudeEvent("Host Welcome Submitted Without Message")
                  }
                })

              document
                .getElementById("change-welcome-message")
                .addEventListener("click", function (e) {
                  document.getElementById("welcome-message-top").innerText =
                    welcomeMessagePart1
                  document.getElementById("welcome-message-bottom").value =
                    document
                      .getElementById("message-text")
                      .value.replace(welcomeMessagePart1, "")
                  document
                    .getElementById("change-welcome-message-question")
                    .classList.add("hide")
                  document
                    .getElementById("change-welcome-message-wrapper")
                    .classList.add("hide")
                  document
                    .getElementById("change-welcome-message-form")
                    .classList.remove("hide")
                  logAmplitudeEvent("Default Welcome Message Change")
                })

              document
                .getElementById("update-button")
                .addEventListener("click", async function (e) {
                  let customiseForm = document.getElementById("customise-form")
                  if (customiseForm.checkValidity()) {
                    e.preventDefault()
                    let button = document.getElementById("update-button")
                    let buttonText = button.value
                    window.requestAnimationFrame(() => {
                      button.value = "Please wait..."
                      button.disabled = true
                    })
                    try {
                      const updateWelcomeData = await util.api
                        .post("update-welcome-message", {
                          json: {
                            id: id,
                            default_welcome_message: document.getElementById(
                              "welcome-message-bottom"
                            ).value,
                          },
                          retry: { limit: 0 },
                        })
                        .json()
                      if (updateWelcomeData.success) {
                        document.getElementById("error-section").style.display =
                          "none"
                        Toastify({
                          text: "Your default welcome message has been changed.",
                          duration: 4000,
                          close: true,
                          gravity: "top",
                          position: "center",
                          stopOnFocus: true,
                          style: {
                            background: "#1aa979",
                          },
                        }).showToast()
                        button.disabled = false
                        button.value = buttonText
                        logAmplitudeEvent("Default Welcome Message Updated")
                      } else {
                        console.error("invalid data")
                        document.getElementById("error-message").innerHTML =
                          'An error occurred while updating your message. Please try again later or contact us: <a href="mailto:venuesupport@sharesy.com" class="link-red">venuesupport@sharesy.com</a>.'
                        document.getElementById("error-section").style.display =
                          "flex"
                        button.disabled = false
                        button.value = buttonText
                        logAmplitudeEvent(
                          "Error Updating Default Welcome Message"
                        )
                      }
                    } catch (err) {
                      document.getElementById("error-message").innerHTML =
                        'An error occurred while updating your message. Please try again later or contact us: <a href="mailto:venuesupport@sharesy.com" class="link-red">venuesupport@sharesy.com</a>.'
                      document.getElementById("error-section").style.display =
                        "flex"
                      button.disabled = false
                      button.value = buttonText
                      logAmplitudeEvent(
                        "Error Updating Default Welcome Message",
                        { error: err.toString() }
                      )
                    }
                  } else {
                    customiseForm.reportValidity()
                    logAmplitudeEvent("Host Welcome Updated Without Message")
                  }
                })
            }
          } catch (err) {
            document.getElementById("error-message").innerHTML =
              'An error occurred while confirming the transaction. Please try again later or contact us: <a href="mailto:venuesupport@sharesy.com" class="link-red">venuesupport@sharesy.com</a>.'
            document.getElementById("error-section").style.display = "flex"
            document.getElementById("host-confirmed").style.display = "none"
            document.getElementById("preloader-background").style.display =
              "none"
            logAmplitudeEvent("Error During Host Confirm", {
              error: err.toString(),
            })
          }
          document.getElementById("preloader-background").style.display = "none"
        } else {
          logAmplitudeEvent("Missing Host Confirm Transaction ID")
          document.getElementById("host-confirmed").style.display = "none"
          document.getElementById("error-section").style.display = "flex"
          document.getElementById("preloader-background").style.display = "none"
        }
      } catch (err) {
        util.logToSentry(err)
      }
    }

    function hostCancelInit() {
      try {
        let id = searchParams.get("id")
        if (id) {
          let declineReasonSelect = document.getElementById("decline-reason")
          let option = document.createElement("option")
          option.value = ""
          option.disabled = true
          option.selected = true
          option.innerText = "Select a decline reason..."
          declineReasonSelect.appendChild(option)
          let declineReasons = [
            "Not available - there is another event at this time",
            "Not available - no staff cover",
            "Not available - other reason",
            "The event (or the booker) is not suitable",
            "We need to know more before confirming",
            "The booker has asked to cancel",
            "The price or other info is wrong",
            "Other",
          ]
          declineReasons.forEach(function (declineReason) {
            let option = document.createElement("option")
            option.value = declineReason
            option.innerText = declineReason
            declineReasonSelect.appendChild(option)
          })
          declineReasonSelect.required = true
          document
            .getElementById("decline-reason-question")
            .classList.remove("hide")

          document
            .getElementById("cancel-button")
            .addEventListener("click", async function (e) {
              let cancelForm = document.getElementById("cancel-form")
              if (cancelForm.checkValidity()) {
                e.preventDefault()
                let button = document.getElementById("cancel-button")
                let buttonText = button.value
                button.value = "Please wait..."
                button.disabled = true

                try {
                  let declineReason =
                    document.getElementById("decline-reason").value
                  let declineReasonOther = null
                  if (declineReason === "Other") {
                    declineReasonOther = document.getElementById(
                      "decline-reason-other"
                    ).value
                  }
                  const cancelData = await util.api
                    .post("host-cancel", {
                      json: {
                        id: id,
                        decline_reason: declineReason,
                        decline_reason_other: declineReasonOther,
                        cancel_reason:
                          document.getElementById("cancel-reason").value,
                      },
                      retry: { limit: 0 },
                    })
                    .json()
                  if (cancelData.success) {
                    document
                      .getElementById("cancel-button")
                      .classList.add("hide")
                    document.getElementById("cancel-reason").disabled = true
                    Toastify({
                      text: "Thanks, we've received your cancellation request. Our support team will follow up with the booker - you do not need to take any further action.",
                      duration: 20000,
                      close: true,
                      gravity: "top",
                      position: "center",
                      stopOnFocus: true,
                      style: {
                        background: "#1aa979",
                      },
                    }).showToast()
                    logAmplitudeEvent("Host Cancellation Succeeded")
                  } else {
                    console.error("invalid data")
                    document.getElementById("error-message").innerHTML =
                      'An error occurred while attempting to cancel. Please try again later or contact us: <a href="mailto:venuesupport@sharesy.com" class="link-red">venuesupport@sharesy.com</a>.'
                    document.getElementById("error-section").style.display =
                      "flex"
                    button.disabled = false
                    button.value = buttonText
                    logAmplitudeEvent("Error Attempting Host Cancellation")
                  }
                } catch (err) {
                  document.getElementById("error-message").innerHTML =
                    'An error occurred while attempting to cancel. Please try again later or contact us: <a href="mailto:venuesupport@sharesy.com" class="link-red">venuesupport@sharesy.com</a>.'
                  document.getElementById("error-section").style.display =
                    "flex"
                  button.disabled = false
                  button.value = buttonText
                  logAmplitudeEvent("Error Attempting Host Cancellation", {
                    error: err.toString(),
                  })
                }
              } else {
                cancelForm.reportValidity()
                logAmplitudeEvent("Host Cancellation Submitted Without Reason")
              }
            })

          document
            .getElementById("decline-reason")
            .addEventListener("change", function (e) {
              let selectedDeclineReason =
                e.target.options[e.target.selectedIndex].value
              let declineReasonOther = document.getElementById(
                "decline-reason-other"
              )
              if (selectedDeclineReason === "Other") {
                declineReasonOther.required = true
                declineReasonOther.classList.remove("hide")
              } else {
                declineReasonOther.required = false
                declineReasonOther.innerText = ""
                declineReasonOther.classList.add("hide")
              }
            })
        } else {
          logAmplitudeEvent("Missing Host Cancel Transaction ID")
          document.getElementById("host-cancel").style.display = "none"
          document.getElementById("error-section").style.display = "flex"
        }
      } catch (err) {
        util.logToSentry(err)
      }
    }

    async function hostOnsiteContactInit() {
      try {
        let id = searchParams.get("id")
        let minDate = searchParams.get("min_date")
        let maxDate = searchParams.get("max_date")
        let success = searchParams.get("success")
        if (id) {
          let url = "get-host-onsite-contact?id=" + id
          if (minDate && maxDate) {
            url += "&min_date=" + minDate + "&max_date=" + maxDate
          }
          try {
            const contactData = await util.api
              .get(url, { retry: { limit: 4 } })
              .json()
            if (contactData.count > 1) {
              document.getElementById("onsite-contact").remove()
              let onsiteContactHTML = ""
              contactData.onsite_contacts.forEach((onsiteContact) => {
                onsiteContactHTML +=
                  "<div>On-site number for " +
                  onsiteContact.day_text +
                  ": <strong>" +
                  onsiteContact.onsite_number_text +
                  "</strong>"
                if (onsiteContact.is_override) {
                  onsiteContactHTML += " (alternate)"
                } else {
                  onsiteContactHTML += " (default)"
                }
                if (!onsiteContact.parsed_number) {
                  onsiteContactHTML +=
                    ". This number is invalid, please update it below."
                }
                onsiteContactHTML += "</div>"
              })
              document.getElementById("onsite-contact-message").innerHTML =
                onsiteContactHTML
            } else {
              let onsiteContact = contactData.onsite_contacts[0]
              if (onsiteContact.number) {
                document.getElementById("onsite-contact").innerText =
                  onsiteContact.onsite_number_text
                let willBeUsed = " will be used:"
                if (onsiteContact.dont_send_onsite_contact) {
                  willBeUsed = " will be used by Sharesy only, not the booker:"
                }
                if (!onsiteContact.parsed_number) {
                  willBeUsed =
                    " <strong>is not a valid number - please update it below</strong>."
                }
                let whenText =
                  "booking on " + onsiteContact.event_date_times_string
                if (minDate && maxDate) {
                  whenText = "bookings this weekend"
                }
                if (onsiteContact.is_override) {
                  let validMessage = ""
                  if (
                    onsiteContact.valid_from_str !== onsiteContact.valid_to_str
                  ) {
                    validMessage =
                      "valid from " +
                      onsiteContact.valid_from_str +
                      " to " +
                      onsiteContact.valid_to_str
                  }
                  document.getElementById("onsite-contact-message").innerHTML =
                    "For the " +
                    whenText +
                    ", an alternate on-site number " +
                    validMessage +
                    willBeUsed
                } else {
                  document.getElementById("onsite-contact-message").innerHTML =
                    "For the " +
                    whenText +
                    ", your default on-site number" +
                    willBeUsed
                }
                document.getElementById("start-date").value =
                  onsiteContact.event_date_str
                document.getElementById("end-date").value =
                  onsiteContact.event_date_str
              } else {
                document.getElementById("onsite-contact").remove()
                document.getElementById("onsite-contact-message").innerText =
                  "You don't currently have an on-site contact number set. Please set one below."
              }
            }
            if (success) {
              document
                .getElementById("success-message")
                .classList.remove("hide")
              util.deleteUrlParam("success")
            }
            document.getElementById("preloader-background").style.display =
              "none"
            logAmplitudeEvent("Host Onsite Contact Viewed")
            if (minDate && maxDate) {
              document.getElementById("start-date").value = minDate
              document.getElementById("end-date").value = maxDate
            }
            if (document.querySelector('input[name="onsite"]')) {
              document
                .querySelectorAll('input[name="onsite"]')
                .forEach((elem) => {
                  elem.addEventListener("change", function (event) {
                    if (event.target.value === "default") {
                      document
                        .getElementById("rest-of-form")
                        .classList.remove("hide")
                      document
                        .getElementById("start-date-section")
                        .classList.add("hide")
                      document
                        .getElementById("end-date-section")
                        .classList.add("hide")
                    } else if (event.target.value === "dates") {
                      document
                        .getElementById("rest-of-form")
                        .classList.remove("hide")
                      document
                        .getElementById("start-date-section")
                        .classList.remove("hide")
                      document
                        .getElementById("end-date-section")
                        .classList.remove("hide")
                    }
                  })
                })
            }

            document
              .getElementById("start-date")
              .addEventListener("input", function (e) {
                checkDates()
              })
            document
              .getElementById("end-date")
              .addEventListener("input", function (e) {
                checkDates()
              })

            document
              .getElementById("update-button")
              .addEventListener("click", function (e) {
                e.preventDefault()
                let onsiteForm = document.getElementById("onsite-contact-form")
                if (onsiteForm.checkValidity()) {
                  document.getElementById("error-section").style.display =
                    "none"
                  let button = document.getElementById("update-button")
                  let buttonText = button.value
                  window.requestAnimationFrame(() => {
                    button.value = "Please wait..."
                    button.disabled = true
                  })

                  // When setting the default, check if the current value comes from an override and warn
                  let onsiteRadioValue = document.querySelector(
                    'input[name="onsite"]:checked'
                  ).value
                  if (
                    onsiteRadioValue === "default" &&
                    contactData.has_overrides
                  ) {
                    // If get_host_onsite_contact returns an override for any of the days then warn about that.
                    // Give yes / no options. if yes then set default and add alternate for each date. If no just set default.
                    if (minDate && maxDate) {
                      document.getElementById(
                        "warning-modal-paragraph-1"
                      ).innerHTML = document
                        .getElementById("warning-modal-paragraph-1")
                        .innerHTML.replace(
                          "this event",
                          "one or more days this weekend"
                        )
                      document.getElementById(
                        "warning-modal-paragraph-2"
                      ).innerHTML = document
                        .getElementById("warning-modal-paragraph-2")
                        .innerHTML.replace("this event", "this weekend")
                      document.getElementById("warning-modal-yes").innerText =
                        document
                          .getElementById("warning-modal-yes")
                          .innerText.replace("this event", "this weekend")
                    }
                    document.getElementById("modal-container").style.display =
                      "flex"
                    document.getElementById("warning-modal").style.display =
                      "flex"
                    window.requestAnimationFrame(() => {
                      button.disabled = false
                      button.value = buttonText
                    })
                    logAmplitudeEvent("Display Override Warning Modal")
                    return
                  }
                  setOnsiteContact(false)
                  window.requestAnimationFrame(() => {
                    button.disabled = false
                    button.value = buttonText
                  })
                } else {
                  onsiteForm.reportValidity()
                  logAmplitudeEvent("Set Onsite Contact Form Not Valid")
                }
              })

            document
              .getElementById("warning-modal-yes")
              .addEventListener("click", function (e) {
                logAmplitudeEvent("Accept Adding Overrides")
                setOnsiteContact(true)
              })
            document
              .getElementById("warning-modal-no")
              .addEventListener("click", function (e) {
                logAmplitudeEvent("Decline Adding Overrides")
                setOnsiteContact(false)
              })
            document
              .getElementById("warning-modal-close")
              .addEventListener("click", (e) => {
                document.getElementById("modal-container").style.display =
                  "none"
                document.getElementById("warning-modal").style.display = "none"
                logAmplitudeEvent("Close Override Warning Modal")
              })
            document
              .getElementById("modal-container")
              .addEventListener("click", (e) => {
                if (e.target.id === "modal-container") {
                  document.getElementById("modal-container").style.display =
                    "none"
                  document.getElementById("warning-modal").style.display =
                    "none"
                  logAmplitudeEvent(
                    "Close Override Warning Modal - Click Outside"
                  )
                }
              })
          } catch (err) {
            document.getElementById("error-message").innerHTML =
              'An error occurred while confirming the transaction. Please try again later or contact us: <a href="mailto:venuesupport@sharesy.com" class="link-red">venuesupport@sharesy.com</a>.'
            document.getElementById("error-section").style.display = "flex"
            document.getElementById("host-onsite-contact").style.display =
              "none"
            document.getElementById("preloader-background").style.display =
              "none"
            logAmplitudeEvent("Error During Set Onsite Contact", {
              error: err.toString(),
            })
          }
        } else {
          logAmplitudeEvent("Set Onsite Contact Missing Transaction ID")
          document.getElementById("host-onsite-contact").style.display = "none"
          document.getElementById("error-section").style.display = "flex"
          document.getElementById("preloader-background").style.display = "none"
        }
      } catch (err) {
        util.logToSentry(err)
      }
    }

    function checkDates() {
      let onsiteRadioValue = document.querySelector(
        'input[name="onsite"]:checked'
      ).value
      let endDate = document.getElementById("end-date")
      if (
        onsiteRadioValue === "dates" &&
        document.getElementById("start-date").value > endDate.value
      ) {
        logAmplitudeEvent("Set Onsite Contact Start Date After End Date")
        endDate.setCustomValidity("The end date can't be before the start date")
      } else {
        endDate.setCustomValidity("")
      }
    }

    async function setOnsiteContact(addOverrides) {
      let id = searchParams.get("id")
      let jsonBody = {
        id: id,
        number: document.getElementById("onsite-number").value,
        name: document.getElementById("onsite-name").value,
        has_dates: false,
        valid_from: document.getElementById("start-date").value,
        valid_to: document.getElementById("end-date").value,
        dont_send_onsite_contact: false,
        add_overrides: addOverrides,
      }
      if (
        document.querySelector('input[name="onsite"]:checked').value === "dates"
      ) {
        jsonBody.has_dates = true
      }

      try {
        const onsiteContactData = await util.api
          .post("set-host-onsite-contact", {
            json: jsonBody,
            retry: { limit: 4 },
          })
          .json()
        if (onsiteContactData.success) {
          logAmplitudeEvent("Set Onsite Contact Succeeded")
          let urlParams = new URLSearchParams(location.search.substring(1))
          urlParams.set("success", "1")
          location.search = urlParams.toString()
        } else {
          if (onsiteContactData.invalid_number) {
            let errorMsg =
              "The phone number you entered is not a valid UK number."
            document.getElementById("error-message").innerHTML = errorMsg
            logAmplitudeEvent("Error Attempting Set Onsite Contact", {
              error: errorMsg,
            })
          } else {
            document.getElementById("error-message").innerHTML =
              'An error occurred while attempting to set your on-site contact. Please try again later or contact us: <a href="mailto:venuesupport@sharesy.com" class="link-red">venuesupport@sharesy.com</a>.'
            logAmplitudeEvent("Error Attempting Set Onsite Contact")
          }
          document.getElementById("error-section").style.display = "flex"
          window.scrollBy(0, 100) // Make sure error message is visible
        }
      } catch (err) {
        document.getElementById("error-message").innerHTML =
          'An error occurred while attempting to set your on-site contact. Please try again later or contact us: <a href="mailto:venuesupport@sharesy.com" class="link-red">venuesupport@sharesy.com</a>.'
        document.getElementById("error-section").style.display = "flex"
        logAmplitudeEvent("Error Attempting Set Onsite Contact", {
          error: err.toString(),
        })
      }
    }

    function init() {
      initClerk()

      if (
        window.location.pathname === "/dashboard-host-confirm" ||
        window.location.pathname === "/host-confirm"
      ) {
        hostConfirmInit()
      } else if (
        window.location.pathname === "/dashboard-host-cancel" ||
        window.location.pathname === "/host-cancel"
      ) {
        hostCancelInit()
      } else if (
        window.location.pathname === "/dashboard-onsite-contact" ||
        window.location.pathname === "/host-onsite-contact"
      ) {
        hostOnsiteContactInit()
      }
    }

    return {
      init: init,
      logAmplitudeEvent: logAmplitudeEvent,
    }
  })()
}
